import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { attachList, attachStatus } from './request';
import { unitResource } from './../underwritingManage/request';
import { agencyResource } from './../organizationalManage/request';
import informationModel from './additionalFrom/informationModel.vue';
export default {
  components: {
    informationModel
  },
  data() {
    const h = this.$createElement;
    return {
      form: {
        agencyId: undefined
      },
      // form: {startAt: '', endAt: ''},
      dateArr: [],
      data: [],
      unitList: [],
      intermediaryList: [],
      columns: [{
        slots: {
          title: '产品标识'
        },
        dataIndex: 'mark',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'unitName',
        key: '2',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        },
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.unitName
          }
        }, [record.unitName])
      }, {
        slots: {
          title: '机构全称'
        },
        dataIndex: 'agencyName',
        key: 'description',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        },
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.agencyName
          }
        }, [record.agencyName])
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '6',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 100
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      informationShow: false
    };
  },
  created() {
    this.getDataFun();
    unitResource({}).then(res => {
      this.unitList = res;
    });
    this.agencyFun();
  },
  methods: {
    getDataFun() {
      let obj = this.form;
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      attachList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    agencyFun() {
      this.form.agencyId = undefined;
      agencyResource({
        unitId: this.form.unitId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    checkedFun(val) {
      attachStatus({
        insuranceAttachId: val.insuranceAttachId,
        status: val.status == 1 ? 0 : 1,
        change: false
      }).then(res => {
        if (res.length != 0) {
          this.informationShow = true;
          this.$nextTick(() => {
            console.log(this.$refs.infoRef);
            this.$refs.infoRef.init(res, 1, val.insuranceAttachId);
          });
        } else {
          this.$message.success(this.$t('修改成功') + '!');
          this.getDataFun();
        }
      });
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
    },
    onChange(date) {
      if (date.length != 0) {
        this.form.startAt = date[0];
        this.form.endAt = date[1];
      } else {
        this.form.startAt = '';
        this.form.endAt = '';
      }
    }
  }
};